import {EditorDialogConfirmShowOptions, EditorDialogConfirmOnAcceptCallback} from '../../modules/editor/DialogConfirm';
import {Ref, ref} from 'vue';

export class EditorDialogConfirmStoreControllerClass {
	private static _instance: EditorDialogConfirmStoreControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorDialogConfirmStoreControllerClass());
	}

	private constructor() {}

	private _display: Ref<boolean> = ref(false);
	private _question: Ref<string> = ref('');
	private _accept_label: Ref<string> = ref('');
	private _resolve: EditorDialogConfirmOnAcceptCallback | undefined;
	display(): boolean {
		return this._display.value;
	}
	question(): string {
		return this._question.value;
	}
	accept_label(): string {
		return this._accept_label.value;
	}
	resolve(): EditorDialogConfirmOnAcceptCallback | undefined {
		return this._resolve;
	}

	// mutations
	async show(options: EditorDialogConfirmShowOptions): Promise<boolean> {
		return new Promise((resolve, reject) => {
			this._display.value = true;
			this._question.value = options.question;
			this._accept_label.value = options.accept_label;
			this._resolve = resolve;
		});
	}
	hide() {
		this._display.value = false;
		this._resolve = undefined;
	}
}

export const EditorDialogConfirmStoreController = EditorDialogConfirmStoreControllerClass.instance();
